

























import { Component, Prop, Vue } from "vue-property-decorator";

export interface TableDataRow extends Vue {
  id: string;
  field: string;
  amount: number;
}

@Component
export default class BaseTable extends Vue {
  @Prop({ default: [] }) private data!: any[];
  @Prop() private defaultSortField?: string;
  @Prop({ default: "desc" }) private defaultSortOrder!: string;
  @Prop({ default: false }) private selectable!: boolean;
  @Prop({ default: false }) private loading!: boolean;
  @Prop() private asCard?: boolean;

  get isSelectable() {
    if (this.selectable) {
      return "single";
    }
    return null;
  }

  private onSelect(item: any) {
    if (this.selectable) {
      this.$emit("itemSelected", item);
    }
  }
}
